<script setup>
import { useGlobalStore } from 'src/composables/useGlobalStore'
import { useRoute } from 'vue-router'
import AppDialog from '#/general/AppDialog'
import { useGA } from '#/useGA'
import { ref, watch } from 'vue'
import gsap from 'gsap'

const { event } = useGA()
const { showMobileDrawer, isProduction, isLoggedIn } = useGlobalStore()
const route = useRoute()
const navigationEvent = (path, eventLabel) => {
  if (route.fullPath !== path) {
    event('navigation', { eventCategory: 'button', eventLabel: eventLabel })
  }
  showMobileDrawer.value = false
}

function scrollToContact () {
  const element = document.querySelector('#kontakt')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
    showMobileDrawer.value = false
  }
}
</script>

<template lang="pug">
app-dialog.mobileDrawer(v-model:show-modal="showMobileDrawer" position="left" transition="float" full-screen fixed)
  template(#modal-content)
    .mobileDrawerContainer
      .closeBtn(@click="showMobileDrawer = false")
        svg(width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M8.40994 7.00019L12.7099 2.71019C12.8982 2.52188 13.004 2.26649 13.004 2.00019C13.004 1.73388 12.8982 1.47849 12.7099 1.29019C12.5216 1.10188 12.2662 0.996094 11.9999 0.996094C11.7336 0.996094 11.4782 1.10188 11.2899 1.29019L6.99994 5.59019L2.70994 1.29019C2.52164 1.10188 2.26624 0.996094 1.99994 0.996094C1.73364 0.996094 1.47824 1.10188 1.28994 1.29019C1.10164 1.47849 0.995847 1.73388 0.995847 2.00019C0.995847 2.26649 1.10164 2.52188 1.28994 2.71019L5.58994 7.00019L1.28994 11.2902C1.19621 11.3831 1.12182 11.4937 1.07105 11.6156C1.02028 11.7375 0.994141 11.8682 0.994141 12.0002C0.994141 12.1322 1.02028 12.2629 1.07105 12.3848C1.12182 12.5066 1.19621 12.6172 1.28994 12.7102C1.3829 12.8039 1.4935 12.8783 1.61536 12.9291C1.73722 12.9798 1.86793 13.006 1.99994 13.006C2.13195 13.006 2.26266 12.9798 2.38452 12.9291C2.50638 12.8783 2.61698 12.8039 2.70994 12.7102L6.99994 8.41019L11.2899 12.7102C11.3829 12.8039 11.4935 12.8783 11.6154 12.9291C11.7372 12.9798 11.8679 13.006 11.9999 13.006C12.132 13.006 12.2627 12.9798 12.3845 12.9291C12.5064 12.8783 12.617 12.8039 12.7099 12.7102C12.8037 12.6172 12.8781 12.5066 12.9288 12.3848C12.9796 12.2629 13.0057 12.1322 13.0057 12.0002C13.0057 11.8682 12.9796 11.7375 12.9288 11.6156C12.8781 11.4937 12.8037 11.3831 12.7099 11.2902L8.40994 7.00019Z' fill='white')
      router-link(to="/" @click="navigationEvent('/', 'navigation: B2C')" v-if="showMobileDrawer").mainTitle
        svg(width='94' height='28' viewBox='0 0 94 28' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M4.9195 8.34287H3.25457V12.6187H0V0H6.31848C9.11887 0 10.7073 1.85438 10.7073 4.20058C10.7073 6.39499 9.36417 7.56809 8.19229 7.98341L10.7644 12.6187H7.0374L4.91829 8.34287H4.9195ZM5.82787 2.7421H3.25336V5.58013H5.82665C6.67794 5.58013 7.39686 5.03123 7.39686 4.16172C7.39686 3.29222 6.67794 2.7421 5.82665 2.7421' fill='white')
          path(d='M20.5852 10.7085H15.3451L14.7027 12.6187H11.1652L15.9122 0H19.9986L24.7651 12.6187H21.2276L20.584 10.7085H20.5852ZM16.1964 7.9652H19.7339L17.956 2.83803L16.1964 7.9652Z' fill='white')
          path(d='M24.995 0H28.3054V7.39686C28.3054 8.89178 29.0996 9.97016 30.8593 9.97016C32.6189 9.97016 33.3949 8.89178 33.3949 7.39686V0H36.7054V7.49158C36.7054 10.632 34.9081 12.8446 30.8593 12.8446C26.8105 12.8446 24.995 10.6126 24.995 7.5098V0Z' fill='white')
          path(d='M50.0464 4.10586L46.8501 12.6187H45.4122L42.233 4.10586V12.6187H38.9796V0H43.5008L46.13 7.15155L48.7798 0H53.3009V12.6187H50.0464V4.10586Z' fill='white')
          path(d='M9.38549 14.6641H15.704C18.542 14.6641 20.0928 16.5755 20.0928 18.8646C20.0928 21.1538 18.542 23.0081 15.704 23.0081H12.6388V27.284H9.38428V14.6641H9.38549ZM15.2692 17.4074H12.6401V20.2454H15.2692C16.1399 20.2454 16.7824 19.6977 16.7824 18.8452C16.7824 17.9927 16.1387 17.4074 15.2692 17.4074Z' fill='white')
          path(d='M24.8046 14.6641H21.5513V27.2828H24.8046V14.6641Z' fill='white')
          path(d='M33.1882 14.4561C37.0475 14.4561 39.9232 17.1423 39.9232 20.9834C39.9232 24.8245 37.0475 27.5096 33.1882 27.5096C29.3288 27.5096 26.4349 24.8233 26.4349 20.9834C26.4349 17.1435 29.3288 14.4561 33.1882 14.4561ZM33.1882 17.3317C31.0885 17.3317 29.7454 18.9202 29.7454 20.9834C29.7454 23.0467 31.0885 24.6351 33.1882 24.6351C35.2879 24.6351 36.6128 23.0272 36.6128 20.9834C36.6128 18.9396 35.2696 17.3317 33.1882 17.3317Z' fill='white')
          path(d='M44.8255 19.6589V27.2828H41.5709V14.6641H44.9202L50.0279 21.9298V14.6641H53.3007V27.2828H50.1603L44.8255 19.6589Z' fill='white')
          path(d='M61.0947 14.6641H70.3472V17.4074H64.3493V19.5083H70.2136V22.2698H64.3493V24.5407H70.3472V27.2828H61.0947V14.6641Z' fill='white')
          path(d='M77.1597 23.0081H75.496V27.284H72.2415V14.6641H78.5599C81.3603 14.6641 82.95 16.5184 82.95 18.8646C82.95 21.059 81.6068 22.2322 80.4337 22.6487L83.007 27.284H79.2801L77.161 23.0081H77.1597ZM78.0681 17.4074H75.496V20.2454H78.0681C78.9194 20.2454 79.6383 19.6977 79.6383 18.827C79.6383 17.9563 78.9194 17.4074 78.0681 17.4074Z' fill='white')
          path(d='M84.7495 14.6641H94.0007V17.4074H88.0029V19.5083H93.8684V22.2698H88.0029V24.5407H94.0007V27.2828H84.7495V14.6641Z' fill='white')
          path(d='M55.6027 14.6641H58.7941V27.2828H55.6027' fill='white')

      router-link(to="/referenzen" @click="navigationEvent('/referenzen', 'navigation: References')").menu Referenzen
      router-link(to="/solutions" @click="navigationEvent('/solutions', 'navigation: Solutions')").menu Lösungen
      router-link(to="/insights" @click="navigationEvent('/insights', 'navigation: Insights')").menu Insights
      ul.expandableMenu
        router-link(to="/blogs" @click="navigationEvent('/blogs', 'navigation: Blog')")
          li.expandableMenuItem Blog
        router-link(to="/glossary" @click="navigationEvent('/glossary', 'navigation: Glossary')")
          li.expandableMenuItem Glossar
      router-link(to="/about-us" @click="navigationEvent('/about-us/', 'navigation: About Us')").menu Über uns
      div(@click="scrollToContact").menu Kontakt
</template>

<style lang="sass">
.mobileDrawer
  z-index: 100
.mobileDrawerContainer
  width: 339px
  height: 100vh
  background: linear-gradient(152.99deg, #2F3849 24.83%, #21252E 103.84%)
  padding: 27px 21px
  display: flex
  flex-direction: column
  position: relative
  .closeBtn
    cursor: pointer
    position: absolute
    top: 25px
    right: 25px
  .mainTitle
    font-weight: 700
    font-size: 28px
    line-height: 40px
    color: #FFFFFF
    text-decoration: none
    margin-bottom: 45px

  .expandableMenuTitle
    cursor: pointer
    font-size: 20px
    line-height: 36px
    font-weight: 500
    color: #DFE4EC
  .expandableMenu
    margin-top: 0px
    margin-bottom: 0px
    a
      text-decoration: none !important
    .expandableMenuItem
      font-size: 20px
      line-height: 36px
      font-weight: 500
      color: #DFE4EC
      margin-bottom: 5px
  .menu
    font-weight: 500
    font-size: 20px
    line-height: 36px
    color: #DFE4EC
    text-decoration: none
</style>
